import Axios from './axios_wrapper'

export function getSystemNotifications () {
  return Axios({
    url: `/system_notifications`,
    method: 'GET'
  })
}

export function getAdminSystemNotifications () {
  return Axios({
    url: `/admin/system_notifications`,
    method: 'GET'
  })
}

export function createSystemNotificaton (data) {
  return Axios({
    url: `/admin/system_notifications`,
    method: 'POST',
    data
  })
}

export function removeSystemNotification (data) {
  return Axios({
    url: `/admin/system_notifications/${data.id}`,
    method: 'DELETE',
    data
  })
}

export function updateSystemNotification (data) {
  return Axios({
    url: `/admin/system_notifications/${data.id}`,
    method: 'PATCH',
    data
  })
}

export function dismissSystemNotifications (data) {
  return Axios({
    url: `/system_notifications/dismissals`,
    method: 'POST',
    type: 'NOTYPE',
    data: {
      system_notification_ids: data
    }
  })
}




//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/system_notifications.js
// module id = null
// module chunks = 